const kidney_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"form1[0].Page_1[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"form1[0].Page_1[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].Page_1[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "maxLength":105,
      "radioGroup":"form1[0].Page_1[0].PublicEvidenceReview[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"form1[0].Page_1[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
      "textanswer":""
   },


   {
      "question":"Does ##name## have renal dysfunction?",
      "sub":"",
      "type":"yesnoouter",
      "show": true,
      "section": {
         page: "3",
         title: "RENAL DYSFUNCTION",
         number: "3A"
      },
      "presidence":"Yes",
      "outer_ref": 7,
      "dbqName_yes":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].YES_Renal_dysfunction[0]",
      "dbqName_no":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].NO_Renal_dysfunction[0]",
      "answer":"",
   },
   {
      "question":"Does ##name## require regular dialysis?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "RENAL DYSFUNCTION",
         number: "3B"
      },
      "presidence":"Yes",
      "ref":0,
      "outer_refId":1,
      "dbqName_yes":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].YES_Dialysis[0]",
      "dbqName_no":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].NO_Dialysis[0]",
      "answer":"",
   },
   {
      "question":"Does ##name## have a cystic, obstructive, or glomerular structural kidney abnormality for at least 3 consecutive months during the past 12 months?",
      "sub":"If yes, check all that apply and discuss test(s)/evidence used to confirm the structural abnormality",
      "type":"checkbox",
      "multi": false,
      "small": true,
      "show": false,
      "outer_refId":2,
      "cols": 2,
      "section": {
         page: "3",
         title: "RENAL DYSFUNCTION",
         number: "3C"
      },
      "questions":[
         {
            "main":"Abnormality observed",
            "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].YES_structural_abnormalities[0]",
            "answer":"",
            "text1": "",
            "placeholder1": "Tests/evidence",
            "dbqName1": "form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Test_evidence_discussion[0]",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Cystic",
                  "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Cystic[0]",
                  "answer":""
               },
               {
                  "main":"Obstructive",
                  "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Obstructive[0]",
                  "answer":""
               },
               {
                  "main":"Glomerular",
                  "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Glomerual[0]",
                  "answer":""
               }
            ],
         },
         {
            "main":"No abnormality observed",
            "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].NO_structural_abnormalities[0]",
            "answer":"",
         }       
      ],
      "answer":""
   },
   {
      "question":"Is there a renal tubular disorder?",
      "sub":"",
      "type":"yesno",
      "show": false,
      "section": {
         page: "3",
         title: "RENAL DYSFUNCTION",
         number: "3D"
      },
      "radioGroup": "form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Renal_tubular_disorder[0]",
      "presidence":"Yes",
      "ref":1,
      "outer_refId":3,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Is the renal tubular disorder symptomatic?",
      "sub":"",
      "type":"yesno",
      "show": false,
      "section": {
         page: "3",
         title: "RENAL DYSFUNCTION",
         number: "3D"
      },
      "radioGroup":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Is_renal_tubular_symptomatic[1]",
      "presidence":"Yes",
      "refId":1,
      "outer_refId":4,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Does ##name## have any signs or symptoms of hydronephrosis due to obstruction other than upper urinary tract urolithiasis?",
      "sub":"",
      "type":"yesno",
      "show": false,
      "section": {
         page: "3",
         title: "RENAL DYSFUNCTION",
         number: "3E"
      },
      "radioGroup":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Signs_symptoms_hydronephrosis[0]",
      "presidence":"Yes",
      "ref":1,
      "outer_refId":5,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Indicate severity for symptoms of hydronephrosis due to obstruction other than upper urinary tract urolithiasis",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "show": false,
      "small": true,
      "refId":1,
      "outer_refId":6,
      "cols": 2,
      "section": {
         page: "3",
         title: "RENAL DYSFUNCTION",
         number: "3E"
      },
      "questions":[
         {
            "main":"Requires catheter drainage",
            "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Catheter_drainage[0]",
            "answer":""
         },
         {
            "main":"Causing infection (pyonephrosis)",
            "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Infection_pyonephrosis[0]",
            "answer":""
         },
         {
            "main":"Causing impaired kidney function",
            "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Impaired_kidney_function[0]",
            "answer":""
         },
         {
            "main":"Other",
            "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Other_symptoms[0]",
            "answer":"",
            "textarea": true,
            "maxLength":40,
            "textdbqName" : "form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Describe_other[0]",
            "placeholder": "describe other signs and symptoms",
            "textAnswer": ""
         }           
      ],
      "answer":""
   },
   {
      "question":"Does ##name## have attacks of renal colic due to obstruction other than upper urinary tract urolithiasis?",
      "sub":"",
      "type":"checkbox",
      "multi": false,
      "small": true,
      "show": false,
      "outer_refId":7,
      "radioGroup": "form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Hydronephrosis_colic[0]",
      "cols": 2,
      "section": {
         page: "3",
         title: "RENAL DYSFUNCTION",
         number: "3F"
      },
      "questions":[
         {
            "main":"Attacks observed",
            "dbqName":"1",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Occasional attacks of colic",
                  "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Occasional_colic[0]",
                  "answer":""
               },
               {
                  "main":"Frequent attacks of colic",
                  "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Frequent_colic[0]",
                  "answer":""
               }
            ],
         },
         {
            "main":"No attacks observed",
            "dbqName":"2",
            "answer":"",
         }       
      ],
      "answer":""
   },

   {
      "question":"Does ##name## now have or ever had kidney or ureteral calculi (urolithiasis)?",
      "sub":"",
      "type":"yesnoouter",
      "show": true,
      "section": {
         page: "4",
         title: "UROLITHIASIS",
         number: "4A"
      },
      "radioGroup":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Calculi[0]",
      "presidence":"Yes",
      "outer_ref": 7,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Indicate current/past location of calculi",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": false,
      "small": true,
      "outer_refId":1,
      "cols": 2,
      "section": {
         page: "4",
         title: "UROLITHIASIS",
         number: "4B"
      },
      "questions":[
         {
            "main":"Kidney",
            "dbqName":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Kidney[0]",
            "answer":""
         },
         {
            "main":"Ureter",
            "dbqName":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Ureter[0]",
            "answer":""
         }         
      ],
      "answer":""
   },
   {
      "question":"Does the stone formation cause stricture of the ureter?",
      "sub":"",
      "type":"yesno",
      "show": false,
      "section": {
         page: "4",
         title: "UROLITHIASIS",
         number: "4C"
      },
      "presidence":"Yes",
      "maxLength":105,
      "radioGroup":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Ureter_stricture[0]",
      "ref":0,
      "outer_refId":2,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please discuss test(s)/evidence used to confirm ureteral stricture",
      "textdbqName":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Tests_to_confirm_stricture[0]",
      "textanswer":""
   },
   {
      "question":"Does ##name## have treatment for recurrent stone formation in the kidney or ureter?",
      "sub":"",
      "type":"yesno",
      "show": false,
      "section": {
         page: "4",
         title: "UROLITHIASIS",
         number: "4D"
      },
      "radioGroup":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Treatment_for_stone_formation[0]",
      "presidence":"Yes",
      "ref":1,
      "outer_refId":3,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Indicate treatment for recurrent stone formation in the kidney or ureter",
      "sub":"Check all that apply",
      "type":"radioModal",
      "multi": true,
      "show": false,
      "small": true,
      "cols": 2,
      "refId":1,
      "outer_refId":4,
      "section": {
         page: "4",
         title: "UROLITHIASIS",
         number: "4D"
      },
      "questions":[
         {
            "main":"Diet therapy required",
            "dbqName":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Diet_therapy[0]",
            "answer":"",
            "showSubItems": false,
            "text1": "",
            "dbqName1": "form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Specify_diet_dates[0]",
            "placeholder1":"Specify diet and dates of use",
            "rows1": 3,
         }, 
         {
            "main":"Drug therapy required",
            "dbqName":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Drug_therapy[0]",
            "answer":"",
            "showSubItems": false,
            "text1": "",
            "dbqName1": "form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Medication_dates[0]",
            "placeholder1":"Specify diet and dates of use",
            "rows1": 3,
         }, 
         {
            "main":"Total ankle joint replacement",
            "dbqName":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Requiring_Invasive_Noninvasive[0]",
            "answer":"",
            "multi": false,
            "showSubItems": false,
            "text1": "",
            "dbqName1": "form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Dateandnameoffacility[0]",
            "placeholder1":"Dates and facility of most recent invasive or non-invasive procedure",
            "rows1": 3,
            "subItems": [
               {
                  "main":"0 to 1 per year",
                  "dbqName":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].oneyear[0]",
                  "colWidth": 4,
                  "answer":""
               },
               {
                  "main":"2 per year",
                  "dbqName":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].twoyear[0]",
                  "colWidth": 3,
                  "answer":""
               },
               {
                  "main":"more than 2 per year",
                  "dbqName":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].morethan2year[0]",
                  "colWidth": 5,
                  "answer":""
               }               
            ],
            "subAnswer":"",
            "subItemsLabel" :"Number of Procedures"
         }                       
      ],
      "answer":""
   },
   {
      "question":"Does ##name## have any signs or symptoms due to upper urinary tract urolithiasis?",
      "sub":"",
      "type":"yesno",
      "show": false,
      "section": {
         page: "4",
         title: "UROLITHIASIS",
         number: "4E"
      },
      "radioGroup":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Urolithiasis_symptoms[0]",
      "presidence":"Yes",
      "ref":1,
      "outer_refId":5,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Indicate severity for signs or symptoms due to upper urinary tract urolithiasis",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "show": false,
      "small": true,
      "refId":1,
      "outer_refId":6,
      "cols": 2,
      "section": {
         page: "4",
         title: "UROLITHIASIS",
         number: "4E"
      },
      "questions":[
         {
            "main":"Requires catheter drainage",
            "dbqName":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Requires_Catheter_Drainage[0]",
            "answer":""
         },
         {
            "main":"Causing infection (pyonephrosis)",
            "dbqName":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Causing_Infection[0]",
            "answer":""
         },
         {
            "main":"Causing hydronephrosis",
            "dbqName":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Causing_Hydronephrosis[0]",
            "answer":""
         },
         {
            "main":"Causing impaired kidney function",
            "dbqName":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Causing_Impaired_kidney_function[0]",
            "answer":""
         },
         {
            "main":"Other",
            "dbqName":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Causing_Other[0]",
            "answer":"",
            "textarea": true,
            "maxLength":75,
            "textdbqName" : "form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Describeother[0]",
            "placeholder": "describe other signs and symptoms",
            "textAnswer": ""
         }           
      ],
      "answer":""
   },
   {
      "question":"Does ##name## have attacks of colic due to upper urinary tract urolithiasis?",
      "sub":"",
      "type":"checkbox",
      "multi": false,
      "small": true,
      "show": false,
      "outer_refId":7,
      "radioGroup": "form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Colic_due_to_urolithiasis[0]",
      "cols": 2,
      "section": {
         page: "4",
         title: "UROLITHIASIS",
         number: "4F"
      },
      "questions":[
         {
            "main":"Attacks observed",
            "dbqName":"1",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Occasional attacks of colic",
                  "dbqName":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Occasional_attacks[0]",
                  "answer":""
               },
               {
                  "main":"Frequent attacks of colic",
                  "dbqName":"form1[0].Page_4[0].Section_IV_Urolithiasis_subform[0].Frequent_attacks[0]",
                  "answer":""
               }
            ],
         },
         {
            "main":"No attacks observed",
            "dbqName":"2",
            "answer":"",
         }       
      ],
      "answer":""
   },


   {
      "question":"Additional Comments",
      "sub":"",
      "type":"textarea",
      "optional": true,
      "show": true,
      "section": {
         page: "8",
         title: "REMARKS",
         number: "11A"
      },
      "dbqName":"form1[0].Page_8[0].Section_XI_Remarks_Subform[0].Remarks_field_11A[0]",
      "answer":""
   },
 ]

 export default kidney_questions ;
